import { grid, gridColumnsRoot } from '../../../../utils/grid'
import Quote, { QuoteProps } from '../../../atoms/quote/Quote'
import React, { FunctionComponent } from 'react'
import { mediaQueries } from '../../../../utils/mediaQueries'
import { SectionProps } from '../Sections'
import { spacing } from '../../../../utils/spacing'
import styled from 'styled-components'

export interface QuoteSectionProps extends QuoteProps, SectionProps {}

const QuoteSection: FunctionComponent<QuoteSectionProps> = ({
  artist,
  className,
  quote,
}) => (
  <StyledQuoteSection className={className}>
    <QuoteWrapper>
      <Quote artist={artist} quote={quote} />
    </QuoteWrapper>
  </StyledQuoteSection>
)

const StyledQuoteSection = styled.div`
  ${grid()}
  ${spacing({
    direction: 'both',
    type: 'xlarge',
  })}
`

const QuoteWrapper = styled.div`
  grid-column: 1 / span ${gridColumnsRoot};

  ${mediaQueries.tablet} {
    grid-column: 2 / span 6;
  }

  ${mediaQueries.desktop} {
    grid-column: 4 / span 10;
  }
`

export default QuoteSection
